import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UserNotificationService } from '@macs-frontend/features/shared/services/user-notification.service';
import { NotificationConfirmationDialogService } from '@macs-frontend/features/shared/services/notification-confirmation-dialog.service';
import { UserNotification } from '@macs-frontend/features/shared';

@Component({
  selector: 'md-notifications-menu-item',
  templateUrl: './notifications-menu-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./notifications-menu-item.component.scss'],
})
export class NotificationsMenuItemComponent implements OnInit {
  @Output() countChange = new EventEmitter<number>();

  unreadCount = 0;

  notifications$ = new BehaviorSubject<UserNotification[]>([]);

  constructor(
    private readonly notificationService: UserNotificationService,
    private readonly notificationConfirmationDialogService: NotificationConfirmationDialogService,
    private readonly cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.loadNotifications();
  }

  private loadNotifications() {
    this.notificationService.getUserNotificationList().subscribe(response => {
      this.notifications$.next(response.data);
      this.updateCount(response.data.length);
    });
  }

  private updateCount(count: number) {
    const old = this.unreadCount;
    this.unreadCount = count;
    this.countChange.emit(count - old);
  }

  public showConfirmDialog(notification: UserNotification) {
    this.notificationConfirmationDialogService
      .openFormDialog(notification)
      .subscribe(result => {
        if (!result) {
          return;
        }
        this.notificationService
          .markAsRead(notification.uuid)
          .subscribe(() => this.loadNotifications());
      });
  }
}
